// extracted by mini-css-extract-plugin
export var container = "styles-module--container--5fd39";
export var paddingMd = "styles-module--paddingMd--15d43";
export var paddingSm = "styles-module--paddingSm--618dc";
export var paddingXs = "styles-module--paddingXs--3a3f2";
export var sizeLg = "styles-module--sizeLg--564e0";
export var sizeMd = "styles-module--sizeMd--302ca";
export var sizeSm = "styles-module--sizeSm--b76ae";
export var sizeXs = "styles-module--sizeXs--cbf47";